import { TILE_SIZES } from './constants';

export default [
    {
        id: '2469',
        filterTiles: [
            {
                id: 'tool',
                tilesOrder: [
                    'excel',
                    'word',
                    'power_bi',
                    'google_data_studio'
                ]
            }
        ]
    },
    {
        id: '2468',
        filterTiles: [
            {
                id: 'tool',
                tilesOrder: [
                    'arcgis',
                    'qgis',
                    'google_earth_pro'
                ]
            }
        ]
    },
    {
        id: '2466',
        filterTiles: [
            {
                id: 'tool',
                tilesOrder: [
                    'power_bi',
                    'tableau',
                    'excel',
                    'google_data_studio',
                    'd3_js'
                ]
            }
        ]
    },
    {
        id: '2467',
        filterTiles: [
            {
                id: 'tool',
                tilesOrder: [
                    'power_bi',
                    'tableau',
                    'excel',
                    'google_data_studio',
                    'd3_js'
                ]
            }
        ]
    },
    {
        id: '2461',
        filterTiles: [
            {
                id: 'technology',
                tilesOrder: [
                    'excel',
                    'google_sheets',
                    'spss',
                    'r',
                    'google_analytics',
                    'python'
                ]
            }
        ]
    },
    {
        id: '2462',
        filterTiles: [
            {
                id: 'technology',
                tilesOrder: [
                    'excel',
                    'google_sheets',
                    'spss',
                    'r',
                    'google_analytics',
                    'python'
                ]
            }
        ]
    },

    {
        id: '2463',
        filterTiles: [
            {
                id: 'technology',
                tilesOrder: [
                    'excel',
                    'google_sheets',
                    'spss',
                    'r',
                    'google_analytics',
                    'python'
                ]
            }
        ]
    },

    {
        id: '2464',
        filterTiles: [
            {
                id: 'technology',
                tilesOrder: [
                    'excel',
                    'google_sheets',
                    'spss',
                    'r',
                    'google_analytics',
                    'python'
                ]
            }
        ]
    },

    {
        id: '2465',
        filterTiles: [
            {
                id: 'technology',
                tilesOrder: [
                    'excel',
                    'google_sheets',
                    'spss',
                    'r',
                    'google_analytics',
                    'python'
                ]
            }
        ]
    },

    {
        id: '2471',
        filterTiles: [
            {
                id: 'technology',
                tilesOrder: [
                    'excel',
                    'google_sheets',
                    'spss',
                    'r',
                    'google_analytics',
                    'python'
                ]
            }
        ]
    },
    {
        id: '2376',
        filterTiles: [
            {
                id: 'genre',
                tilesOrder: [
                    'hip_hop',
                    'pop',
                    'r_b',
                    'edm',
                    'trap',
                    'house',
                    'lofi',
                    'rap',
                    'dancehall',
                    'future_bass',
                    'drill'
                ]
            }
        ]
    },
    {
        id: '2377',
        filterTiles: [
            {
                id: 'genre',
                tilesOrder: [
                    'hip_hop',
                    'pop',
                    'r_b',
                    'edm',
                    'trap',
                    'house',
                    'lofi',
                    'rap',
                    'dancehall',
                    'future_bass',
                    'drill'
                ]
            }
        ]
    },
    {
        id: '158',
        filterTiles: [
            {
                id: 'gender',
                tilesOrder: [
                    'female',
                    'male',
                    'non_binary'
                ]
            }
        ]
    },
    {
        id: '2358',
        filterTiles: [
            {
                id: 'software',
                tilesOrder: [
                    'streamlabs_obs',
                    'obs_studio',
                    'streamelements',
                    'twitch_app'
                ]
            }
        ]
    },
    {
        id: '2357',
        filterTiles: [
            {
                id: 'software',
                tilesOrder: [
                    'streamlabs_obs',
                    'obs_studio',
                    'streamelements',
                    'twitch_app'
                ]
            }
        ]
    },
    {
        id: '1070',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'ios_android_dual',
                    'android_app',
                    'iphone_ipad_app',
                    'mobile_web',
                    'windows_mobile_app'
                ]
            }
        ]
    },
    {
        id: '1071',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'ios_android_dual',
                    'android_app',
                    'iphone_ipad_app',
                    'mobile_web',
                    'windows_mobile_app'
                ]
            }
        ]
    },
    {
        id: '1072',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'ios_android_dual',
                    'android_app',
                    'iphone_ipad_app',
                    'mobile_web',
                    'windows_mobile_app'
                ]
            }
        ]
    },
    {
        id: '1073',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'ios_android_dual',
                    'android_app',
                    'iphone_ipad_app',
                    'mobile_web',
                    'windows_mobile_app'
                ]
            }
        ]
    },
    {
        id: '2040',
        filterTiles: [
            {
                id: 'programming_language',
                tilesOrder: [
                    'html_css',
                    'javascript',
                    'php',
                    'python',
                    'asp_net',
                    'java',
                    'c'
                ]
            }
        ]
    },
    {
        id: '2041',
        filterTiles: [
            {
                id: 'programming_language',
                tilesOrder: [
                    'html_css',
                    'javascript',
                    'php',
                    'python',
                    'asp_net',
                    'java',
                    'c'
                ]
            }
        ]
    },
    {
        id: '2042',
        filterTiles: [
            {
                id: 'programming_language',
                tilesOrder: [
                    'html_css',
                    'javascript',
                    'php',
                    'python',
                    'asp_net',
                    'java',
                    'c'
                ]
            }
        ]
    },
    {
        id: '2044',
        filterTiles: [
            {
                id: 'programming_language',
                tilesOrder: [
                    'html_css',
                    'javascript',
                    'php',
                    'python',
                    'asp_net',
                    'java',
                    'c'
                ]
            }
        ]
    },
    {
        id: '2045',
        filterTiles: [
            {
                id: 'programming_language',
                tilesOrder: [
                    'html_css',
                    'javascript',
                    'php',
                    'python',
                    'asp_net',
                    'java',
                    'c'
                ]
            }
        ]
    },
    {
        id: '416',
        filterTiles: [
            {
                id: 'development_technology',
                tilesOrder: [
                    'python',
                    'c',
                    'javascript',
                    'java',
                    'html',
                    'css'
                ]
            }
        ]
    },
    {
        id: '2416',
        filterTiles: [
            {
                id: 'gender_and_group',
                tilesOrder: [
                    'women',
                    'unisex',
                    'men'
                ]
            }
        ]
    },
    {
        id: '2414',
        filterTiles: [
            {
                id: 'item_type',
                tilesOrder: [
                    'clothing',
                    'shoes',
                    'accessories'
                ]
            }
        ]
    },
    {
        id: '2412',
        filterTiles: [
            {
                id: 'item_type',
                tilesOrder: [
                    'clothing',
                    'bags'
                ]
            }
        ]
    },
    {
        id: '419',
        filterTiles: [
            {
                id: 'booth_type',
                tilesOrder: [
                    'modular_systems_booth',
                    'custom_made_booth'
                ]
            }
        ]
    },
    {
        id: '154',
        filterTiles: [
            {
                id: 'merch_type',
                tilesOrder: [
                    't_shirts',
                    'clothing_apparel',
                    'mugs',
                    'accessories',
                    'hats'
                ]
            }
        ]
    },
    {
        id: '2280',
        filterTiles: [
            {
                id: 'project_scale',
                tilesOrder: [
                    'building',
                    'building_complex',
                    'object'
                ]
            }
        ]
    },
    {
        id: '2279',
        filterTiles: [
            {
                id: 'project_scale',
                tilesOrder: [
                    'room',
                    'apartment',
                    'building'
                ]
            }
        ]
    },

    {
        id: '2278',
        filterTiles: [
            {
                id: 'project_scale',
                tilesOrder: [
                    'object',
                    'room',
                    'apartment',
                    'building',
                    'building_complex',
                    'neighborhood',
                    'city'
                ]
            }
        ]
    },
    {
        id: '2277',
        filterTiles: [
            {
                id: 'project_scale',
                tilesOrder: [
                    'building',
                    'apartment',
                    'room',
                    'building_complex'
                ]
            }
        ]
    },
    {
        id: '2271',
        filterTiles: [
            {
                id: 'project_scale',
                tilesOrder: [
                    'building',
                    'apartment',
                    'building_complex'
                ]
            }
        ]
    },
    {
        id: '340',
        filterTiles: [
            {
                id: 'illustration_type',
                tileSize: TILE_SIZES.LARGE,
                tilesOrder: [
                    'portrait',
                    'pet_portrait',
                    'caricature'
                ]
            }
        ]
    },
    {
        id: '420',
        filterTiles: [
            {
                id: 'design_technique',
                tilesOrder: [
                    'digital',
                    'hand_drawn'
                ]
            },
            {
                id: 'design_style',
                tileSize: TILE_SIZES.LARGE,
                tilesOrder: [
                    'abstract',
                    'cartoon',
                    'realistic',
                    'seasonal',
                    'collage'
                ]
            }
        ]
    },
    {
        id: '384',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'spanish',
                    'french',
                    'german',
                    'arabic'
                ]
            }
        ]
    },
    {
        id: '332',
        filterTiles: [
            {
                id: 'setting',
                tilesOrder: [
                    'seller_provides_location',
                    'client_provides_location',
                    'screencasting',
                    '360',
                    'black_background'
                ]
            }
        ]
    },
    {
        id: '2341',
        filterTiles: [
            {
                id: 'video_type',
                tilesOrder: [
                    'animated',
                    'live_action'

                ]
            }
        ]
    },
    {
        id: '2333',
        filterTiles: [
            {
                id: 'video_type',
                tilesOrder: [
                    'animated',
                    'live_action'

                ]
            }
        ]
    },
    {
        id: '2330',
        filterTiles: [
            {
                id: 'video_type',
                tilesOrder: [
                    'animated',
                    'live_action'

                ]
            }
        ]
    },
    {
        id: '2328',
        filterTiles: [
            {
                id: 'video_type',
                tilesOrder: [
                    'animated',
                    'live_action'

                ]
            }
        ]
    },
    {
        id: '2329',
        filterTiles: [
            {
                id: 'video_type',
                tilesOrder: [
                    'animated',
                    'live_action'

                ]
            }
        ]
    },
    {
        id: '2331',
        filterTiles: [
            {
                id: 'video_type',
                tilesOrder: [
                    'animated',
                    'live_action'

                ]
            }
        ]
    },
    {
        id: '2332',
        filterTiles: [
            {
                id: 'video_type',
                tilesOrder: [
                    'animated',
                    'live_action'

                ]
            }
        ]
    },
    {
        id: '2489',
        filterTiles: [
            {
                id: 'video_type',
                tilesOrder: [
                    'animated',
                    'live_action'
                ]
            }
        ]
    },
    {
        id: '329',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'facebook',
                    'generic',
                    'instagram',
                    'youtube',
                    'tiktok',
                    'snapchat',
                    'pinterest',
                    'linkedin',
                    'twitter'

                ]
            }
        ]
    },
    {
        id: '2441',
        filterTiles: [
            {
                id: 'explainer_type',
                tilesOrder: [
                    'illustration',
                    'infographics',
                    'text_animation'

                ]
            }
        ]
    },
    {
        id: '2442',
        filterTiles: [
            {
                id: 'explainer_type',
                tilesOrder: [
                    'illustration',
                    'infographics',
                    'text_animation'

                ]
            }
        ]
    },
    {
        id: '2443',
        filterTiles: [
            {
                id: 'explainer_type',
                tilesOrder: [
                    'illustration',
                    'infographics',
                    'text_animation'

                ]
            }
        ]
    },

    {
        id: '335',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'german',
                    'spanish',
                    'french',
                    'italian'

                ]
            }
        ]
    },
    {
        id: '2403',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'german',
                    'spanish',
                    'french'
                ]
            }
        ]
    },
    {
        id: '2404',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'german',
                    'spanish',
                    'french'
                ]
            }
        ]
    },
    {
        id: '430',
        filterTiles: [
            {
                id: 'book_type',
                tilesOrder: [
                    'fiction',
                    'non_fiction'
                ]
            }
        ]
    },
    {
        id: '2240',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'german',
                    'spanish',
                    'italian',
                    'french'
                ]
            },
            {
                id: 'book_type',
                tilesOrder: [
                    'fiction',
                    'non_fiction'
                ]
            },
            {
                id: 'genre',
                tilesOrder: [
                    'self_help_wellness',
                    'children_s_books',
                    'business_management',
                    'science_fiction_fantasy',
                    'romance'
                ]
            }
        ]
    },
    {
        id: '435',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'spanish',
                    'german',
                    'italian'
                ]
            }
        ]
    },
    {
        id: '2091',
        filterTiles: [
            {
                id: 'search_engine',
                tilesOrder: [
                    'google',
                    'bing'
                ]
            }
        ]
    },
    {
        id: '2032',
        filterTiles: [
            {
                id: 'db_type',
                tilesOrder: [
                    'mysql',
                    'ms_sql',
                    'access',
                    'oracle',
                    'sqlite',
                    'postgres',
                    'mongo',
                    'teradata'
                ]
            }
        ]
    },
    {
        id: '2031',
        filterTiles: [
            {
                id: 'db_type',
                tilesOrder: [
                    'mysql',
                    'ms_sql',
                    'access',
                    'oracle',
                    'sqlite',
                    'postgres',
                    'mongo',
                    'teradata'
                ]
            }
        ]
    },
    {
        id: '2030',
        filterTiles: [
            {
                id: 'db_type',
                tilesOrder: [
                    'mysql',
                    'ms_sql',
                    'access',
                    'oracle',
                    'sqlite',
                    'postgres',
                    'mongo',
                    'teradata'
                ]
            }
        ]
    },
    {
        id: '386',
        filterTiles: [
            {
                id: 'podcast_cover_style',
                tilesOrder: [
                    'photographic',
                    'illustrative',
                    'typographic'
                ]
            }
        ]
    },
    {
        id: '50',
        filterTiles: [
            {
                id: 'illustration_style',
                tileSize: TILE_SIZES.LARGE,
                tilesOrder: [
                    'for_children',
                    'realistic_drawing',
                    'comic_cartoon',
                    'manga',
                    'flat',
                    'line_art',
                    'sketch'
                ]
            },
            {
                id: 'artistic_technique',
                tileSize: TILE_SIZES.LARGE,
                tilesOrder: [
                    'freehand_digital',
                    'vector_art',
                    'mixed_media',
                    'pen_ink',
                    'watercolor',
                    'pencil'
                ]
            }
        ]
    },
    {
        id: '2319',
        filterTiles: [
            {
                id: 'design_style',
                tilesOrder: [
                    'illustrative',
                    'photographic',
                    'typographic'
                ]
            }
        ]
    },
    {
        id: '2318',
        filterTiles: [
            {
                id: 'design_style',
                tilesOrder: [
                    'illustrative',
                    'photographic',
                    'typographic'
                ]
            }
        ]
    },
    {
        id: '392',
        filterTiles: [
            {
                id: 'genre',
                tilesOrder: [
                    'pop',
                    'hip_hop',
                    'rap',
                    'r_b',
                    'edm'
                ]
            }
        ]
    },
    {
        id: '156',
        filterTiles: [
            {
                id: 'instrument',
                tilesOrder: [
                    'guitar',
                    'drums',
                    'bass',
                    'piano',
                    'keyboards'
                ]
            }
        ]
    },
    {
        id: '235',
        filterTiles: [
            {
                id: 'animation_type',
                tilesOrder: [
                    '2d',
                    '3d'
                ]
            }
        ]
    },
    {
        id: '384',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'spanish',
                    'french',
                    'german',
                    'arabic'
                ]
            }
        ]
    },
    {
        id: '249',
        filterTiles: [
            {
                id: 'type',
                tilesOrder: [
                    'weddings_events',
                    'family_travel',
                    'corporate',
                    'sports_games',
                    'elearning'
                ]
            }
        ]
    },
    {
        id: '334',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'german',
                    'french',
                    'italian',
                    'spanish'
                ]
            }
        ]
    },
    {
        id: '1029',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1006',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1005',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1004',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1003',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1001',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1002',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            },
            {
                id: 'spcecialization',
                tilesOrder: [
                    'blog_magazine',
                    'corporate',
                    'education',
                    'portfolio',
                    'entertainment',
                    'wedding'
                ]
            }
        ]
    },
    {
        id: '1000',
        filterTiles: [
            {
                id: 'spcecialization',
                tilesOrder: [
                    'blog_magazine',
                    'corporate',
                    'education',
                    'portfolio',
                    'entertainment',
                    'wedding'
                ]
            },
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1019',
        filterTiles: [
            {
                id: 'spcecialization',
                tilesOrder: [
                    'blog',
                    'business',
                    'education',
                    'portfolio',
                    'entertainment',
                    'wedding'
                ]
            }
        ]
    },
    {
        id: '1007',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1008',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1009',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1010',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1011',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1012',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1013',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '2405',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'shopify',
                    'amazon',
                    'ebay',
                    'etsy',
                    'woocommerce'
                ]
            }
        ]
    },
    {
        id: '2151',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'shopify',
                    'amazon',
                    'ebay',
                    'etsy',
                    'woocommerce'
                ]
            }
        ]
    },
    {
        id: '2307',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'youtube',
                    'linkedin'
                ]
            }
        ]
    },
    {
        id: '2308',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'youtube',
                    'linkedin'
                ]
            }
        ]
    },
    {
        id: '2309',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'youtube',
                    'linkedin'
                ]
            }
        ]
    },
    {
        id: '54',
        filterTiles: [
            {
                id: 'purpose',
                tilesOrder: [
                    'marketing',
                    'investor_pitch_fundraising',
                    'business_proposal',
                    'education_training',
                    'sales',
                    'conference'
                ]
            }
        ]
    },
    {
        id: '2060',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'linkedin',
                    'twitter',
                    'youtube'
                ]
            }
        ]
    },
    {
        id: '2061',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'linkedin',
                    'twitter',
                    'youtube'
                ]
            }
        ]
    },
    {
        id: '2062',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'linkedin',
                    'twitter',
                    'youtube'
                ]
            }
        ]
    },
    {
        id: '2063',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'linkedin',
                    'twitter',
                    'youtube'
                ]
            }
        ]
    },
    {
        id: '2065',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'linkedin',
                    'twitter',
                    'youtube'
                ]
            }
        ]
    },
    {
        id: '49',
        filterTiles: [
            {
                id: 'style',
                tileSize: TILE_SIZES.LARGE,
                tilesOrder: [
                    'flat_minimalist',
                    '3d',
                    'mascot_cartoon',
                    'signature',
                    'hand_drawn',
                    'retro',
                    'watercolor_feminine'
                ]
            }
        ]
    },
    {
        id: '371',
        filterTiles: [
            {
                id: 'asset_type',
                tilesOrder: [
                    'emotes_badges',
                    'overlays_screen_packs',
                    'panels',
                    'thumbnails',
                    'banners',
                    'alerts'
                ]
            }
        ]
    },
    {
        id: '99',
        filterTiles: [
            {
                id: 'service_type',
                tilesOrder: [
                    'ads_social_media_videos',
                    'corporate_videos',
                    'gaming_videos',
                    'family_videos',
                    'music_videos',
                    'explainer_videos',
                    'event_videos',
                    'showreels',
                    'fiction_films',
                    'movie_trailers',
                    'elearning',
                    'vr_360_video'
                ]
            }
        ]
    },
    {
        id: '16',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'german',
                    'french',
                    'arabic',
                    'italian',
                    'spanish'
                ]
            },
            {
                id: 'gender',
                tilesOrder: [
                    'female',
                    'male'
                ]
            }
        ]
    },
    {
        id: '163',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'spanish',
                    'french',
                    'german',
                    'italian',
                    'dutch'
                ]
            },
            {
                id: 'topic',
                tilesOrder: [
                    'internet_technology',
                    'health_medical',
                    'lifestyle',
                    'business_finance_law',
                    'beauty_fashion',
                    'marketing'
                ]
            }
        ]
    }
];
